export const USER_UPDATED = "USER_UPDATED";
export const PROFILE_UPDATED = "PROFILE_UPDATED";
export const GET_PROFILE = "GET_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR";
export const DELEGATOR_UPDATED = "DELEGATEOR_UPDATED";
export const GET_DELEGATOR = "GET_DELEGATOR";
export const DELEGATEE_UPDATED = "DELEGATEEE_UPDATED";
export const GET_DELEGATEE = "GET_DELEGATEE";
export const UPDATE_DELEGATEES = "UPDATE_DELEGATEES";
export const DELETE_DELEGATEES = "DELETE_DELEGATEES";
export const UPDATE_DELEGATEES_RESPONSE = "UPDATE_DELEGATEE_RESPONSE";
